import { Card } from '@/components/ui/card';
import { Calculator } from 'lucide-react';
import { format } from 'date-fns';

interface ClientCalculationsProps {
  calculations: any[];
}

export const ClientCalculations = ({ calculations }: ClientCalculationsProps) => {
  return (
    <Card className="p-6 bg-[#222222] border-white/10">
      {calculations && calculations.length > 0 ? (
        <div className="space-y-4">
          {calculations.map((calc) => (
            <div key={calc.id} className="border border-white/10 rounded-lg p-4">
              <div className="flex items-center gap-2 mb-2">
                <Calculator className="h-4 w-4 text-primary" />
                <span className="text-white font-medium">
                  Calculation from {format(new Date(calc.created_at || ''), 'PPP')}
                </span>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-gray-400">Monthly Savings</p>
                  <p className="text-white">R{calc.monthly_savings}</p>
                </div>
                <div>
                  <p className="text-gray-400">Yearly Savings</p>
                  <p className="text-white">R{calc.yearly_savings}</p>
                </div>
                <div>
                  <p className="text-gray-400">New Repayment</p>
                  <p className="text-white">R{calc.new_repayment}</p>
                </div>
                <div>
                  <p className="text-gray-400">Reduction Percentage</p>
                  <p className="text-white">{calc.reduction_percentage}%</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-400">No calculations found for this client.</p>
      )}
    </Card>
  );
};